import { useIsLaptop } from '@utils/hooks/useIsLaptop';
import { useIsMobile } from '@utils/hooks/useIsMobile';
import { useIsTablet } from '@utils/hooks/useIsTablet';

type DeviceTypes = 'laptop' | 'tablet' | 'mobile' | 'default';

export function useGetDevice(): DeviceTypes {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  const isLaptop = useIsLaptop();

  if (isLaptop) {
    return 'laptop';
  } else if (isTablet) {
    return 'tablet';
  } else if (isMobile) {
    return 'mobile';
  }
  return 'default';
}
